import React from 'react'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import { useEffect } from 'react';
import "../styles/website.css"
import { Link, useNavigate } from 'react-router-dom';
import FAQ from '../components/Faqs';
import testimonial from "../assets/img/testimonial/t.webp"
import testimonial1 from "../assets/img/testimonial/t2.webp"
import testimonial2 from "../assets/img/testimonial/t3.webp"
import testimonial3 from "../assets/img/testimonial/t4.webp"
import { RiDoubleQuotesL } from "react-icons/ri";
import { RiDoubleQuotesR } from "react-icons/ri";
import { GoDash } from "react-icons/go";
import CaseStudy from '../components/CaseStudy';
import heroImg from "../assets/img/r1.avif"
import "../styles/digitalMarketing.css"
import { IoIosArrowRoundDown } from "react-icons/io";
import servicesImg from "../assets/img/s.jpg"
import ServicesCards from '../components/ServicesCards';
import CaseStudyGallery from '../components/CaseStudyGallery';
import AboutSection from '../components/AboutSection';
import { Banner } from '../components/Banner';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const AnalyticsInsights = () => {

 
  

    const navigate = useNavigate();
  
  
  const handleContactBtn = () => {
    navigate("/get-in-touch")
  }
  

  return (
    <>
<section className="website-wrapper">
    

  <Nav/>

  <Banner/>
   
 <AboutSection/>
   
  <CaseStudyGallery/>

  <FAQ/>




</section>

{/*
  <section className="client-testimonials">
  <h3>
    What our clients have said <br />
    <span>about our work</span>
  </h3>

  <div className="testimonial-cards">
    <div className="testimonial-card">
      <p className="quote">
        “truly impressed with his mastery in CRO, showcasing remarkable ATTENTION to detail and INNOVATION. The detailed report he delivered provided actionable strategies, and I am eager to implement them to boost my conversion rate.”
      </p>
      <div className="client-info">
        <img
          src={testimonial}
          alt="Tayla Ahrens"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Tayla Ahrens</p>
          <p className="client-title">Marketing Manager — Cairns & Mackay Airport</p>
        </div>
      </div>
    </div>

    <div className="testimonial-card">
      <p className="quote">
        “Bang Media’s ability to blend creativity with strategic thinking is
        remarkable, and it’s clear that they are not just service providers but
        passionate creators who are invested in their clients’ success.”
      </p>
      <div className="client-info">
        <img
          src={testimonial1}
          alt="Will Perrin"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Will Perrin</p>
          <p className="client-title">Director — Computerman</p>
        </div>
      </div>
    </div>

        <div className="testimonial-card">
      <p className="quote">
        “Bryan's CRO report for my investment services business was excellent. He created an easy-to-understand-and-follow video that reviewed my site's key pages and where we should make changes. With Bryan's work, we have a great roadmap for improving our website conversion.”
      </p>
      <div className="client-info">
        <img
           src={testimonial2}
          alt="Tayla Ahrens"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Tayla Ahrens</p>
          <p className="client-title">Marketing Manager — Cairns & Mackay Airport</p>
        </div>
      </div>
    </div>

    <div className="testimonial-card">
      <p className="quote">
        “It was a pleasure working with him throughout the process! He was responsive, ensured that we understood what was needed at each stage of the process, and went above and beyond when necessary”
      </p>
      <div className="client-info">
        <img
           src={testimonial3}
          alt="Will Perrin"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Will Perrin</p>
          <p className="client-title">Director — Computerman</p>
        </div>
      </div>
    </div>
  </div>
</section>
 */}



<section className="booking-wrapper">
  <div className="booking-content">
    <h3>Let's get to work</h3>
    <p>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>

  <Footer/>
</>

  )
}

export default AnalyticsInsights